import React, { Component } from "react";
import styled from "styled-components";
import * as ReactScroll from "react-scroll";
import { withPage } from "../../Page";
import PlaceData from "../../../content/WorldBeanIntro";
import WorldBeanIntroItem from "../../Components/WorldBeanIntroItem";

//FIX ME: For 2019/08/23 release deadline, we make this decision
//1. create new page temporarily: FindMapPage.
//2. apply acceptable styling and layout.
//p.s. original page: FindByMapPage.

class FindMapPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCountry: null
    };
  }

  render() {
    let { selectedCountry } = this.state;

    return (
      <Wrapper
        css={`
          margin-top: 80px;
          @media screen and (max-width: 1000px) {
            margin-top: 40px;
          }
          @media screen and (max-width: 550px) {
            margin-top: 20px;
          }
        `}
      >
        <div className="title">- 搜產地 -</div>
        <div className="subtitle">請選擇你喜愛的產地</div>
        <div className="buttons-section">
          {PlaceData.map((d, i) => (
            <PlaceItem
              key={i}
              selected={selectedCountry === d.country}
              onClick={() => {
                this.setState({
                  selectedCountry: PlaceData.filter(
                    place => d.country == place.country
                  )[0].country
                });

                if (window.innerWidth <= 1000) {
                  ReactScroll.animateScroll.scrollMore(350);
                }
              }}
            >
              {d.country_name}
            </PlaceItem>
          ))}
          {/* FAKE ITEMS */}
          <PlaceItem css="min-height: 0px;" />
          <PlaceItem css="min-height: 0px;" />
          <PlaceItem css="min-height: 0px;" />
          <PlaceItem css="min-height: 0px;" />
        </div>

        {selectedCountry && (
          <WorldBeanIntroItem key={selectedCountry} country={selectedCountry} />
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;

  & > .title {
    margin-bottom: 20px;
    letter-spacing: 3.9px;
    font-size: 26px;
  }

  & > .subtitle {
    margin-bottom: 50px;
    font-size: 14px;
    color: #636363;
  }

  & > .buttons-section {
    max-width: 660px;
    width: 100%;

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  @media screen and (max-width: 600px) {
    & > .buttons-section {
      justify-content: center;
    }
  }

  ${props => props.css};
`;

const PlaceItem = styled.div`
  min-width: 100px;
  min-height: 40px;
  box-shadow: 0 2px 8px -2px rgba(58, 58, 58, 0.5);
  border-radius: 5px;

  cursor: pointer;
  background: ${props => (props.selected ? "#bd9f84" : "#ffffff")};
  color: ${props => (props.selected ? "#ffffff" : "#000000")};
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  margin-bottom: 10px;

  & > :last-child {
    margin-right: 0px;
  }

  ${props => props.css};
`;

export default withPage(FindMapPage);
